import React from 'react'

import { platformMap, currentMonth, currentMonthShort, currentYear } from '../utils/constants';

import { blockfiWithdrawalsRaw, blockfiRowInfoUS, blockfiRates } from  './blockfi-info';
import { celsiusRates, celsiusRowInfoUS } from './celsius-info';
import { haruRates, haruWithdrawals, haruInfoUS } from './haru-info';
import { hodlnautRates, hodlnautWithdrawalsRaw, hodlnautInfoUS } from './hodlnaut-info';
import { geminiRates, geminiWithdrawalsRaw, geminiRowInfoUS } from './gemini-info';
import { cryptoComWithdrawals, cryptoComRates, cryptoComRowInfoUS } from './crypto-com-info';
import { lednRates, lednWithdrawals, lednInfoInt } from './ledn-info';
import { finbloxRates, finbloxRowInfoInt } from './finblox-info';
import { nexoRates, nexoRowInfoInt } from './nexo-info';
import { vauldRates, vauldRowInfoUS } from './vauld-info';
import { krakenWithdrawals, krakenRates, krakenRowInfoUS } from './kraken-info';
import { upholdWithdrawals, upholdRates, upholdRowInfoUS } from './uphold-info';
import { robinhoodWithdrawals, robinhoodRates, robinhoodRowInfoUS } from './robinhood-info';

const hodlnautExcerpt = `With Hodlnaut, you get one free crypto withdrawal per month (completely free, they cover network fees). The table below shows the withdrawal fees for each supported cryptocurrency and stablecoin, after your one free withdrawal:`;
const cryptoComExcerpt = <span>The table below shows the Crypto.com Earn withdrawal fees of {currentMonth} {currentYear}, for each supported cryptocurrency and stablecoin. <b>Note:</b> These are the withdrawal fees for <em>only</em> the assets that are part of the Crypto Earn program.</span>;

const cryptoComCustomDescription = `Crypto.com Earn withdrawal fees of ${currentMonthShort} ${currentYear}, for each supported cryptocurrency and stablecoin. See the cost to withdraw each asset in the Crypto.com Earn program.`;

const krakenCustomDescription = `Kraken withdrawal fees of staking assets, for ${currentMonthShort} ${currentYear}. See the cost to withdraw each cryptocurrency and stablecoin in the Kraken Staking Rewards program.`;

const robinhoodCustomDescription = `Robinhood crypto withdrawal fees for staking and Robinhood Earn, of ${currentMonthShort} ${currentYear}. See the cost to withdraw each asset in Robinhood Staking and Robinhood Earn.`;

export const slugToWithdrawalFeesMap = {
    [platformMap.blockfi.withdrawalSlug]: {
        ...platformMap.blockfi,
        withdrawalFees: blockfiWithdrawalsRaw,
        bonusHTML: blockfiRates.bonusHTML,
        bonus: blockfiRowInfoUS.bonus,
    },
    [platformMap.gemini.withdrawalSlug]: {
        ...platformMap.gemini,
        withdrawalFees: geminiWithdrawalsRaw,
        bonusHTML: geminiRates.bonusHTML,
        bonus: geminiRowInfoUS.bonus,
    },
    [platformMap.celsius.withdrawalSlug]: {
        ...platformMap.celsius,
        bonusHTML: celsiusRates.bonusHTML,
        bonus: celsiusRowInfoUS.bonus,
    },
    [platformMap.hodlnaut.withdrawalSlug]: {
        ...platformMap.hodlnaut,
        withdrawalFees: hodlnautWithdrawalsRaw,
        bonusHTML: hodlnautRates.bonusHTML,
        bonus: hodlnautInfoUS.bonus,
        customExcerpt: hodlnautExcerpt,
    },
    [platformMap.cryptoCom.withdrawalSlug]: {
        ...platformMap.cryptoCom,
        withdrawalFees: cryptoComWithdrawals,
        bonusHTML: cryptoComRates.bonusHTML,
        name: 'Crypto.com App',
        bonus: cryptoComRowInfoUS.bonus,
        customExcerpt: cryptoComExcerpt,
        customDescription: cryptoComCustomDescription,
    },
    [platformMap.haru.withdrawalSlug]: {
        ...platformMap.haru,
        withdrawalFees: haruWithdrawals,
        bonusHTML: haruRates.bonusHTML,
        bonus: haruInfoUS.bonus,
    },
    [platformMap.ledn.withdrawalSlug]: {
        ...platformMap.ledn,
        withdrawalFees: lednWithdrawals,
        bonusHTML: lednRates.bonusHTML,
        bonus: lednInfoInt.bonus,
    },
    [platformMap.finblox.withdrawalSlug]: {
        ...platformMap.finblox,
        bonusHTML: finbloxRates.bonusHTML,
        bonus: finbloxRowInfoInt.bonus,
    },
    [platformMap.nexo.withdrawalSlug]: {
        ...platformMap.nexo,
        bonusHTML: nexoRates.bonusHTML,
        bonus: nexoRowInfoInt.bonus,
    },
    [platformMap.vauld.withdrawalSlug]: {
        ...platformMap.vauld,
        bonusHTML: vauldRates.bonusHTML,
        bonus: vauldRowInfoUS.bonus,
    },
    [platformMap.kraken.withdrawalSlug]: {
        ...platformMap.kraken,
        withdrawalFees: krakenWithdrawals,
        bonusHTML: krakenRates.bonusHTML,
        bonus: krakenRowInfoUS.bonus,
        customDescription: krakenCustomDescription,
        customExcerpt: krakenCustomDescription,
    },
    [platformMap.uphold.withdrawalSlug]: {
        ...platformMap.uphold,
        withdrawalFees: upholdWithdrawals,
        bonusHTML: upholdRates.bonusHTML,
        bonus: upholdRowInfoUS.bonus,
    },
    [platformMap.robinhood.withdrawalSlug]: {
        ...platformMap.robinhood,
        withdrawalFees: robinhoodWithdrawals,
        bonusHTML: robinhoodRates.bonusHTML,
        bonus: robinhoodRowInfoUS.bonus,
        customDescription: robinhoodCustomDescription,
        customExcerpt: robinhoodCustomDescription,
    },
    // [slugVoyagerWithdrawalFees]: voyagerWithdrawals,
    // [slugAbraWithdrawalFees]: abraWithdrawals,
};
